import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import classNames from 'classnames'
import { Form, Modal } from 'react-bootstrap'
import {
  Button,
  useErrorService,
  useNotificationService,
} from '@abroad/components'
import { SelectionField, useInput } from '../common'
import API from '../../utils/API'
const isValidCoachRate = (value) =>
  value !== '' && value <= 1000 && value >= 0 && Number.isInteger(Number(value))
const defaultValue = '0'

const AddOrgCoachModel = ({
  orgEcoId,
  showModal,
  setShowModal,
  indiSOWCoachIds = [],
  onSuccess,
}) => {
  const {
    value: coachRate,
    hasError: coachRateHasError,
    valueChangeHandler: coachRateChangeHandler,
    inputBlurHandler: coachRateBlurHandler,
    reset: resetCoachRate,
  } = useInput(isValidCoachRate, defaultValue)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [coachId, setCoachId] = useState('')
  const [isLoading, setIsLoading] = useState('')
  const [coachHasError, setCoachHasError] = useState(false)
  const { companyName } = useParams()
  const [coaches, setCoaches] = useState([])
  const Error = useErrorService()
  const Notification = useNotificationService()

  const onHide = () => {
    setShowModal(false)
    resetCoachRate(defaultValue)
    setCoachId('')
  }
  useEffect(() => {
    setIsLoading(true)
    const getCoachData = async () => {
      try {
        const { data } = await API.AdminAPI.teams.getCoachData()
        if (data) {
          const filteredCoaches = data?.filter(
            (coach) => !indiSOWCoachIds.includes(coach?._id),
          )
          setCoaches(
            filteredCoaches?.map((coach) => ({
              label: `${coach?.fullName} ${
                coach?.isStaffCoach ? '(Staff Coach)' : ''
              }`,
              value: coach?._id,
              isStaffCoach: coach?.isStaffCoach || false,
              fullName: coach?.fullName,
              _id: coach?._id,
            })),
          )
        }
        setIsLoading(false)
      } catch (e) {
        Error.showError(e)
        setIsLoading(false)
      }
    }
    if (showModal) getCoachData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal])

  const addGrowthPlanHandler = async () => {
    if (!coachId) setCoachHasError(true)
    if (coachRateHasError || !coachId) return
    setIsSubmitting(true)
    try {
      await API.AdminAPI.entityService.addEntityCoach(
        companyName ? 'company' : 'network',
        orgEcoId,
        {
          coachId,
          hourlyRateForGrowthPlan: parseInt(coachRate),
        },
      )
      setIsSubmitting(false)
      setShowModal(false)
      resetCoachRate(defaultValue)
      if (onSuccess) onSuccess()
      Notification.showNotification(
        'Coach has been assigned to this organization.',
        'success',
      )
    } catch (e) {
      setIsSubmitting(false)
      Error.showError(e)
    }
  }

  if (!showModal) return null

  return (
    <Modal
      show={showModal}
      size='lg'
      onHide={onHide}
      className='custom-modal normal-padding-modal'
      centered>
      <Modal.Header>
        <h3 className='s2 text-center mb-0'>Add Coach </h3>
      </Modal.Header>
      <Modal.Body className='profile'>
        <Form.Group>
          <Form.Label>COACH</Form.Label>
          <SelectionField
            name='coachId'
            size='lg'
            options={coaches}
            getValueAsOption={true}
            optionplaceholder={
              isLoading ? 'Fetching Coaches...' : 'Select Coach'
            }
            sm='10'
            className={classNames('mb-3', {
              'bg-white cursor-pointer': !isSubmitting,
              'disabled-input': isSubmitting,
              'is-invalid': coachHasError,
            })}
            isUseFormikSelectionField={false}
            value={coachId}
            onChange={(e) => {
              setCoachHasError(false)
              setCoachId(e.target.value)
            }}
            disabled={isSubmitting}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>HOURLY RATE PAID TO COACH (USD)</Form.Label>
          <Form.Control
            name='coachRate'
            type='number'
            size='lg'
            placeholder='Hourly Rate'
            value={coachRate}
            onChange={coachRateChangeHandler}
            onBlur={coachRateBlurHandler}
            className='s6 border-radius-3'
            isInvalid={coachRateHasError}
            disabled={isSubmitting}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <div className='text-right'>
          <Button
            variant='saffron'
            className='line-height-normal'
            disabled={isSubmitting}
            isLoading={isSubmitting}
            size='md'
            onClick={addGrowthPlanHandler}>
            Save
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default AddOrgCoachModel
